import { useStorage } from '@vueuse/core'
import jwtDecode from 'jwt-decode'
import { defineStore } from 'pinia'
import { computed } from 'vue'

export type DecodedAttendanceShareToken =
  | {
      type: 'UploadFile'
      uuid: string
      attendanceId: number
      config: Record<string, never>
    }
  | {
      type: 'Calculator'
      uuid: string
      attendanceId: number
      config: {
        questionId: number
        calculator: string
      }
    }

export const useAttendanceShareTokenStore = defineStore('attendance-share-token', () => {
  const token = useStorage<string | null>('kintsu-attendance-share-token', null, sessionStorage)

  const data = computed(() => {
    if (!token.value) {
      return null
    }

    try {
      return jwtDecode<DecodedAttendanceShareToken>(token.value)
    } catch (error) {
      console.error(error)
      return null
    }
  })

  return {
    token,
    data,
  }
})
